import HTTP from "../http";
import Jsona from "jsona";

const dataFormatter = new Jsona();

const index = async () => {
  try {
    const response = await HTTP.normal.get("/credit-cards");

    return dataFormatter.deserialize(response.data);
  } catch (e) {
    throw e;
  }
};

const clear = async id => {
  try {
    await HTTP.normal.post(`/credit-cards/${id}/clear`);
  } catch (e) {
    throw e;
  }
};

const updateCardName = async (id, name) => {
  try {
    const data = {
      data: {
        type: "credit_cards",
        id,
        attributes: { name }
      }
    };

    await HTTP.normal.patch(`/credit-cards/${id}`, data);
  } catch (e) {
    throw e;
  }
};

export default {
  index,
  clear,
  updateCardName
};



// WEBPACK FOOTER //
// ./src/api/modules/creditCards.js